import createCachedSelector from 're-reselect'
import { selectCurrentTicketMailboxId } from 'selectors/tickets'
import selectIntegrationSettingsForId from 'ducks/integrations/selectors/selectIntegrationSettingsForId'
import { isEmpty } from 'util/objects'

const selectCanDisplayForCurrentTicketMailbox = createCachedSelector(
  selectIntegrationSettingsForId,
  selectCurrentTicketMailboxId,
  (integrationSettingsForId, currentTicketMailboxId) => {
    if (!currentTicketMailboxId || isEmpty(integrationSettingsForId))
      return false

    const mailboxSetting =
      integrationSettingsForId[`mailboxes.${currentTicketMailboxId}`]

    // not all credentials have the mailbox setting e.g. 'mailboxes.123456: true'
    return mailboxSetting === undefined ? true : mailboxSetting
  }
)((_, id) => id || 'unknown')

export default selectCanDisplayForCurrentTicketMailbox
